<template>
    <svg
        width="16"
        height="17"
        viewBox="0 0 16 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clip-path="url(#clip0_2313_245)">
            <path
                d="M7 1.07735C7.6188 0.720085 8.3812 0.720085 9 1.07735L13.9282 3.92265C14.547 4.27992 14.9282 4.94017 14.9282 5.6547V11.3453C14.9282 12.0598 14.547 12.7201 13.9282 13.0774L9 15.9226C8.3812 16.2799 7.6188 16.2799 7 15.9226L2.0718 13.0774C1.45299 12.7201 1.0718 12.0598 1.0718 11.3453V5.6547C1.0718 4.94017 1.45299 4.27992 2.0718 3.92265L7 1.07735Z"
                fill="#48E4FF"
            />
            <path
                d="M5.03472 6.50954C5.03472 6.13773 5.15408 5.76097 5.39285 5.37935C5.63154 4.99774 5.97996 4.68169 6.43788 4.43116C6.89583 4.18071 7.4301 4.05542 8.04067 4.05542C8.60814 4.05542 9.10919 4.16019 9.54366 4.36952C9.97812 4.57895 10.3137 4.86371 10.5505 5.22376C10.7873 5.58392 10.9057 5.97527 10.9057 6.39798C10.9057 6.7307 10.8382 7.02236 10.7032 7.27278C10.5681 7.52331 10.4076 7.73955 10.2217 7.92152C10.0358 8.10354 9.70213 8.40983 9.22072 8.84037C9.08763 8.96174 8.98091 9.06843 8.90075 9.16038C8.82049 9.25237 8.76077 9.33652 8.72168 9.4128C8.68251 9.48914 8.65213 9.56545 8.63067 9.64179C8.60911 9.71808 8.57683 9.85222 8.53381 10.044C8.45942 10.4511 8.22651 10.6546 7.83517 10.6546C7.63162 10.6546 7.46034 10.5881 7.32145 10.4549C7.18248 10.3219 7.11304 10.1242 7.11304 9.86197C7.11304 9.53318 7.16386 9.24842 7.26569 9.00772C7.36744 8.76697 7.50245 8.55562 7.67079 8.37365C7.83902 8.19163 8.06608 7.97541 8.35182 7.72488C8.60227 7.50573 8.78335 7.34033 8.8949 7.22877C9.00646 7.11721 9.10038 6.99302 9.17671 6.85594C9.25303 6.71897 9.29121 6.57028 9.29121 6.40974C9.29121 6.09663 9.17471 5.83245 8.94187 5.61714C8.70896 5.40193 8.40852 5.29422 8.04067 5.29422C7.61005 5.29422 7.29302 5.40284 7.08955 5.62008C6.886 5.83731 6.71382 6.15729 6.5729 6.58C6.43981 7.02236 6.18733 7.24344 5.81553 7.24344C5.59627 7.24344 5.41134 7.16619 5.26072 7.01153C5.11005 6.85693 5.03472 6.68961 5.03472 6.50954ZM7.89978 12.9443C7.66098 12.9443 7.45257 12.867 7.27451 12.7124C7.09637 12.5578 7.00736 12.3416 7.00736 12.0636C7.00736 11.817 7.0934 11.6096 7.26569 11.4413C7.43787 11.273 7.64923 11.1888 7.89975 11.1888C8.14635 11.1888 8.35375 11.273 8.52208 11.4413C8.69031 11.6096 8.77453 11.817 8.77453 12.0636C8.77453 12.3377 8.68646 12.5529 8.51032 12.7095C8.33419 12.866 8.13069 12.9443 7.89978 12.9443Z"
                fill="#050607"
            />
        </g>
        <defs>
            <clipPath id="clip0_2313_245">
                <rect
                    width="16"
                    height="16"
                    fill="white"
                    transform="translate(0 0.5)"
                />
            </clipPath>
        </defs>
    </svg>
</template>

<script>
export default {
    data() {
        return {};
    },
};
</script>
